
<script lang="ts" setup>
import useStaticData from '@/composables/useStaticData'

const { getItems } = useStaticData()
const items = await getItems(['policy'])
const { surveillance } = items
</script>

<template>
  <div class="surveillance">
    <UiPolicy
      :title="$t('surveillance.title')"
      :subtitle="$t('surveillance.subtitle')"
      :policy="surveillance"
      :table-of-contents="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.surveillance {
  :deep() {
    .policy__header--primary {
      max-width: 132rem;
    }

    .policy__header-subtitle--primary {
    max-width: 132rem;
}
  }
}
</style>
